// @ts-nocheck
import FileUpload, { FileUploadProps } from "@insite/mobius/FileUpload";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import { getGridPreset } from "@toolkit/Framework/Common/Utilities/gridPreset";
import upperFirst from "lodash/upperFirst";
import React, { FC } from "react";
import { useTheme } from "styled-components";

const errorText = "This field is invalid.";

const Row: FC<FileUploadProps> = ({ label, ...props }) => (
    <>
        <GridItem width={4}>
            <FileUpload label={label} {...props} />
        </GridItem>
        <GridItem width={4}>
            <FileUpload label={`${label} (Disabled)`} disabled {...props} />
        </GridItem>
        <GridItem width={4}>
            <FileUpload label={`${label} (Error)`} error={errorText} required {...props} />
        </GridItem>
    </>
);

const Variant: FC<FileUploadProps> = ({ sizeVariant }) => {
    const theme = useTheme();
    const gridContainerProps = getGridPreset(theme.design.form.grid.base);

    return (
        <StyleguideSection variant="h3" title={upperFirst(sizeVariant)}>
            <GridContainer {...gridContainerProps}>
                <Row label="Base" sizeVariant={sizeVariant} />
                <Row label="File" sizeVariant={sizeVariant} fileName="myfile.csv" />
                <Row label="Placeholder" sizeVariant={sizeVariant} placeholder="Upload your file" />
                <Row label="No Button" sizeVariant={sizeVariant} hideButton />
                <Row label="No Button With File" sizeVariant={sizeVariant} hideButton fileName="myfile.csv" />
                <GridItem width={4}>
                    <FileUpload label="Hint" sizeVariant={sizeVariant} hint="This is a field description." />
                </GridItem>
                <GridItem width={4}>
                    <FileUpload
                        label="Hint &amp; Error"
                        sizeVariant={sizeVariant}
                        hint="This is a field description."
                        error={errorText}
                    />
                </GridItem>
            </GridContainer>
        </StyleguideSection>
    );
};

const StyleguideFileUploads: FC = () => (
    <StyleguideSection title="File Uploads">
        <Variant sizeVariant="default" />
        <Variant sizeVariant="small" />
        <Variant sizeVariant={"xsmall" as any} />
    </StyleguideSection>
);

export default StyleguideFileUploads;
